import {useEffect, useState, useRef} from 'react'

import {API_BASE_URL} from 'config'
import {WhiteListIP} from 'constData'
import Maintenance from 'views/Maintenance'
import GlobalStyle from 'views/Maintenance/SiteDefaultStyle'

const SiteView = ({children}) => {
  const fetchData = async () => {
    await fetch('maintenance.json')
      .then(res => res.json())
      .then(res => setData(res))
      .catch(e => console.error(e))
  }

  // eslint-disable-next-line no-unused-vars
  const fetchIP = async () => {
    const url = API_BASE_URL + 'get_user_ip'

    await fetch(url)
      .then(res => res.json())
      .then(res => {
        const ipMatch = WhiteListIP.includes(res.ip)
        setIP(ipMatch)
      })
      .catch(e => console.error(e))
  }

  const [data, setData] = useState(fetchData)
  const [ip, setIP] = useState(false)
  const timer = useRef(0)

  useEffect(() => {
    timer.current = setInterval(fetchData, 3000)

    return () => clearInterval(timer.current)
  }, [])

  useEffect(() => {
    if (data?.status) {
      // fetchIP()
    }
  }, [data.status])

  return (
    <>
      {data?.status ? (
        ip ? (
          children
        ) : (
          <>
            <GlobalStyle />
            <Maintenance />
          </>
        )
      ) : (
        children
      )}
    </>
  )
}

export default SiteView
